import React, { useState } from 'react';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import { AnchorLink } from 'react-anchor-navigation';
import './CardLogo.scss';
import './CardLogo-media.scss';
import { Props } from './interfaces';
import {Link} from "../Link/Link";


const CardLogo = ({ card, widthWindow }: Props) => {
  const { logo, width, link, linkOut, hash } = card;
  const [colorFilter, setColorFilter] = useState(true);

  const Logo =
    typeof logo === 'string' ? (
      <div style={{ backgroundImage: `url(${logo})`, width: `${width}%` }} className="card-logo__color" />
    ) : (
      <div
        style={{ width: `${width}%` }}
        className={`card-logo__color-svg${
          colorFilter && widthWindow > 720 ? ' card-logo__color-svg-filter' : ''
        }`}
      >
        {logo}
      </div>
    );

  if (!link) {
    return (
      <div
        className="card-logo"
        onMouseEnter={() => setColorFilter(false)}
        onMouseLeave={() => setColorFilter(true)}
      >
        {Logo}
      </div>
    );
  }

  if (hash) {
    return (
      <AnchorLink
        href={link}
        activeClassName="selected"
        className="card-logo"
        onMouseEnter={() => setColorFilter(false)}
        onMouseLeave={() => setColorFilter(true)}
      >
        {Logo}
      </AnchorLink>
    );
  }

  return linkOut ? (
    <a
      href={link}
      target="_blank"
      className="card-logo"
      onMouseEnter={() => setColorFilter(false)}
      onMouseLeave={() => setColorFilter(true)}
      rel="nofollow"
    >
      {Logo}
    </a>
  ) : (
    <Link
      to={link}
      className="card-logo"
      onMouseEnter={() => setColorFilter(false)}
      onMouseLeave={() => setColorFilter(true)}
    >
      {Logo}
    </Link>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(CardLogo));
